import { flow } from 'mobx-state-tree';

import { getStores } from '../..';

let isFetching = false;
let abortController = new AbortController();

// prettier-ignore
function getQueryString(bounds, language, categories, provider) {
  const { _ne, _sw } = bounds;
  return `?nwLat=${_ne.lat}&nwLon=${_sw.lng}&seLat=${_sw.lat}&seLon=${
    _ne.lng
  }&lang=${language}&${categories}${provider ? `&providers=${provider}` : ''}`;
}

export const fetchPoiList = flow(function* (self, bounds) {
  const { config, categories } = getStores(self, 'config', 'categories');

  if (config.gysService.useMock) return;

  const categoryString = categories
    .getSelected()
    .map((category) => `categories[]=${category.name}`)
    .join('&');

  const params = new URL(document.location).searchParams;
  const provider = params.get('provider');

  if (!categories.list?.filter((cat) => cat.selected)?.length) {
    self.list = [];
    return;
  }
  try {
    if (isFetching) {
      abortController.abort();
      abortController = new AbortController();
    }
    isFetching = true;
    const { signal } = abortController;
    const response = yield fetch(
      `${config.gysService.url}/get-your-spot/location${getQueryString(
        bounds,
        config.gysService.language,
        categoryString,
        provider,
      )}`,
      {
        crossDomain: true,
        credentials: 'include',
        signal,
      },
    );
    const responseJson = yield response.json();
    if (!Array.isArray(responseJson)) return;
    if (!self.hasClearFlag) {
      // TODO check if perfomance is fine (otherwise maybe use Set)
      const newList = self.list;
      responseJson.forEach((newPoi) => {
        if (self.list.filter((poi) => newPoi.id === poi.id).length <= 0) {
          newList.push(newPoi);
        }
      });
      self.list = newList;
    } else {
      self.list = responseJson;
      self.hasClearFlag = false;
    }
    isFetching = false;
  } catch (error) {
    if (error.message !== 'The user aborted a request.') console.error(error);
  }
});
